import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { isNullOrUndefined } from 'is-what';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'card-sem-comunicacao-dashboard',
    templateUrl: './card-sem-comunicacao-dashboard.component.html',
    styleUrls: ['./card-sem-comunicacao-dashboard.component.css'],
    standalone: true,
    imports: [NgIf, NgFor]
})
export class CardSemComunicacaoDashboardComponent implements OnInit {

  @Input() roteiros = [];
  @Output() abrirModalMapa = new EventEmitter<number>();  

  data = new Date().toDateString();
  showTable: boolean = false;
  todosRoteiros = [];

  constructor() { }

  ngOnInit() 
  {
    this.todosRoteiros = this.roteiros;
  }

  formataMinutos(minutos){
    if(!isNullOrUndefined(minutos) && minutos >= 0){
      if(minutos <= 60){
        return minutos + " minuto(s)";
      }else if(minutos <= 1440){
        let aux = minutos/60;
        return aux.toFixed(0) + " hora(s)"
      }else{
        let aux = minutos/24/60;
        return aux.toFixed(0) + " dia(s)";
      }
    }else{
      return '-';
    }
  }

  idRoteiro(idRoteiro){
    this.abrirModalMapa.emit(idRoteiro);
  }

  atualizaRoteiroSemComunicacao(roteirosFiltrados: any[]){
    this.roteiros = this.todosRoteiros.filter((roteiro) => roteirosFiltrados.includes(roteiro.roteiro))   
  }
}
